import { TreeSelectConfig } from './generic-treeselect.component';
import { buildTree, buildTreeFromNested } from '@shared/helpers';

// Department Tree Select Configuration - All departments
export const DEPARTMENT_TREE_SELECT_CONFIG: TreeSelectConfig = {
    service: null, // Will be injected
    method: 'getAll',
    treeBuilder: buildTree,
    valueField: 'id',
    placeholder: 'Chọn phòng ban',
    selectionMode: 'single'
};

// Department Tree Select Configuration - Root departments only
export const ROOT_DEPARTMENT_TREE_SELECT_CONFIG: TreeSelectConfig = {
    service: null, // Will be injected
    method: 'getRoots',
    treeBuilder: (departments: any[]) => {
        // For root departments, we don't need hierarchy, just convert to tree nodes
        return departments.map(dept => ({
            key: dept.id,
            data: dept,
            label: dept.name,
            children: []
        }));
    },
    valueField: 'id',
    placeholder: 'Chọn phòng ban gốc',
    selectionMode: 'single'
};

// Department Tree Select Configuration - Using new POST getOptions API
export const DEPARTMENT_BY_PARENT_TREE_SELECT_CONFIG: TreeSelectConfig = {
    service: null, // Will be injected
    method: 'getOptions',
    usePostMethod: true,
    idField: 'id',
    treeBuilder: buildTreeFromNested,
    valueField: 'id',
    placeholder: 'Chọn phòng ban',
    selectionMode: 'single',
    bodyBuilder: (searchTerm: string, baseQuery: any, idQuery?: any) => {
        const body: any = {};
        const trimmedSearchTerm = searchTerm.trim();

        if (idQuery && idQuery.id) {
            // When searching by ID (for pre-selected values)
            body.andQ = { id: idQuery.id };
        } else if (searchTerm && trimmedSearchTerm) {
            // When searching by text (user typing in filter)
            body.orQ = {
                name: trimmedSearchTerm
            };
        }

        // Add any base query filters (always apply these)
        if (baseQuery && Object.keys(baseQuery).length > 0) {
            if (!body.andQ) {
                body.andQ = {};
            }
            body.andQ = { ...body.andQ, ...baseQuery };
        }

        return body;
    },
    onDependencyChange: (parentId: any) => {
        return parentId ? { id: parentId } : {};
    }
};



// Cluster Tree Select Configuration - All clusters
export const CLUSTER_TREE_SELECT_CONFIG: TreeSelectConfig = {
    service: null, // Will be injected
    method: 'getAll',
    treeBuilder: (clusters: any[]) => buildTree(clusters, { labelFormatter: (cluster: any) => `${cluster.name}` }),
    valueField: 'id',
    placeholder: 'Chọn cụm cha',
    selectionMode: 'single'
};




// TA Capability Tree Select Configuration - Top-level by TaTaskType, children (levels) for TEACHING_ASSIST and TUTOR
import { TaTaskType, TA_TASK_TYPE_CONFIG } from '@shared/enums/training.enum';
import { PaginationRequest } from '@shared/services/models/pagination/pagination.request.model';

export const TA_CAPABILITY_TREE_SELECT_CONFIG: TreeSelectConfig = {
    service: null, // Will be injected
    method: 'getCourseLevels',
    valueField: 'id',
    placeholder: 'Chọn năng lực',
    // selectionMode: 'checkbox',
    additionalParams: new PaginationRequest({ limit: 1000, sort: 'sortIndex,asc' }),
    treeBuilder: (data: any) => {
        const order: string[] = [
            TaTaskType.PLACEMENT,
            TaTaskType.STUDY_SPACE,
            TaTaskType.TEACHING_ASSIST,
            TaTaskType.TUTOR,
            TaTaskType.PROCTOR,
            TaTaskType.EXAMINER
        ];
        const lvlList = Array.isArray(data.items) ? data.items : [];
        return order.map(type => {
            const cfg: any = (TA_TASK_TYPE_CONFIG as any)[type] || {};
            const children = (type === TaTaskType.TEACHING_ASSIST || type === TaTaskType.TUTOR)
                ? lvlList.map((lv: any) => ({
                    key: `${type}|${lv?.id}`,
                    label: lv?.name || lv?.code || String(lv?.id),
                    selectable: true
                }))
                : [];
            return {
                key: type,
                label: cfg.label || type,
                selectable: true,
                children
            } as any;
        });
    }
};
